import React from 'react';
import { Card } from '@app/screens/rewards/components/Card';
import { HStack, Text, Box } from '@chakra-ui/react';
import { SubmitButton } from '@app/components/SubmitButton';
import { useToggle } from 'react-use';
import { DivdendsModal } from '@app/screens/rewards/components/DividendsModal';
import { useDividentsStats } from '@app/hooks/ryo/useDividentsStats';
import { formatNumber, toOptionalFixed } from '@app/helpers/format';
import { useDeallocate } from '@app/hooks/ryo/useDeallocate';

export const AllocationWidget = () => {
  const [showDialog, toggleShowDialog] = useToggle(false);
  const { totalAllocation, dividendsShare, isLoading } = useDividentsStats();
  const { usageAllocation: userAllocation } = useDeallocate();

  function renderInfoRow(label: string, value: string) {
    return (
      <HStack justifyContent="space-between">
        <Text fontSize="16px" fontWeight={400} lineHeight="26px" color="gray.4">
          {label}
        </Text>
        <Text fontSize="16px" fontWeight={500} lineHeight="26px" color="gray.4">
          {value}
        </Text>
      </HStack>
    );
  }

  return (
    <Card title="Your allocation">
      <Box
        sx={{
          '> div:not(:last-of-type)': {
            marginBottom: '14px'
          }
        }}
      >
        {renderInfoRow(
          'Allocated',
          `${userAllocation ? toOptionalFixed(+userAllocation, 2) : '-'} xKIM`
        )}
        {renderInfoRow(
          'Dividends share',
          `${dividendsShare ? formatNumber(dividendsShare, 2) : ''}%`
        )}
      </Box>
      <SubmitButton
        isLoading={false}
        onClick={toggleShowDialog}
        label="Allocate"
      />
      <DivdendsModal
        isOpen={showDialog}
        onClose={() => toggleShowDialog(false)}
      />
    </Card>
  );
};
